import user from './user'
import orders from './orders'
import productListCache from './productListCache'

export default {
  user,
  orders,
  productListCache
}
